import React from 'react';
import PropTypes from 'prop-types';

import emptyInboxIcon from '../../../assets/images/icons/inbox-empty.svg';

// Empty-state copy + CTAs for the inbox. Rendered in both the conversations list (left pane)
// and the conversation area (right pane) when conversations.length === 0 and no search/filter
// is active. Copy + buttons branch on the active mailbox and the viewer's profile type.
//
// CTA URLs match the existing V1 navbar destinations:
//   - /sources             — Source Directory (Media)
//   - /reporter_requests/new — new request form (Media)
//   - /source_requests     — Opportunities feed (PR)
// The inbox is primarily V1-hosted during v99, so V1 URLs are the intended target.

function InboxEmptyState({ mailbox, isMedia }) {
  if (mailbox === 'trash') {
    return (
      <div
        className="d-flex flex-column align-items-center justify-content-center text-center px-4 h-100 flex-grow-1"
        data-testid="inbox-empty-state"
      >
        <img src={emptyInboxIcon} alt="" className="mb-3" style={{ width: 96, height: 96 }} />
        <p className="paragraph-lg fw-semibold text-body mb-1">Trash is empty</p>
        <p className="paragraph-md text-secondary mb-0">Deleted messages appear here.</p>
        <p className="paragraph-md text-secondary mb-0">
          You have 30 days to restore them or they will delete permanently.
        </p>
      </div>
    );
  }

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center px-4 h-100 flex-grow-1"
      data-testid="inbox-empty-state"
    >
      <img src={emptyInboxIcon} alt="" className="mb-3" style={{ width: 96, height: 96 }} />
      <p className="paragraph-lg fw-semibold text-body mb-1">Your Inbox is empty</p>
      <p className="paragraph-md text-secondary mb-3">
        {isMedia ? 'All messages and pitches will appear here.' : 'All messages will appear here.'}
      </p>
      {isMedia ? (
        <div className="d-flex flex-column">
          <a href="/sources" className="btn btn-primary btn-sm mb-2" style={{ padding: '12px 16px' }}>
            <i className="fa-solid fa-message me-2" />
            Connect with a source
          </a>
          <a href="/reporter_requests/new" className="btn btn-secondary btn-sm" style={{ padding: '12px 16px' }}>
            <i className="fa-solid fa-megaphone me-2" />
            Call for Experts/Products
          </a>
        </div>
      ) : (
        <a href="/source_requests" className="btn btn-primary btn-sm" style={{ padding: '12px 16px' }}>
          <i className="fa-solid fa-megaphone me-2" />
          Browse Opportunities
        </a>
      )}
    </div>
  );
}

InboxEmptyState.propTypes = {
  mailbox: PropTypes.oneOf(['focused', 'everything', 'trash']),
  isMedia: PropTypes.bool,
};

export default InboxEmptyState;
